import { FilterQueryPropsValue } from '@model/FilterFields'

export const extractValueFromFilterQuery = (
  filterQueryPropsValue: FilterQueryPropsValue
): string => {
  const value =
    typeof filterQueryPropsValue === 'object' ? filterQueryPropsValue.value : filterQueryPropsValue

  if (value === undefined) {
    return ''
  }

  return value.toString()
}
